export default __webpack_public_path__ + "static/media/feed4.af0150c7.jpg";